<script setup>
import { computed, inject , watch, ref} from 'vue'
import { useEntityStore } from '@/store/useEntityStore'
import { useUserStore } from '@/store/user'
import { useLoaderStore } from "@/store/loader"
const userStore = useUserStore()
const loader = useLoaderStore()
const entityStore = useEntityStore()
import {useLogger} from "@/composables/useLogger"
const {sendLog} = useLogger() 

defineOptions({
  inheritAttrs: false
})
const props = defineProps({
  modelValue: [Object, String],
  label: String,
  field: Object,
  drawerMode: String
})


const updateEntity = inject('updateEntity')
const resetEntity = inject('resetEntity')
const entityState = inject('entityState')
const disableFormSubmission = inject('toggleSubmit')

const baseItems = computed(() => {
  return entityStore.entities[props.field.entityType]?.items ?? []
})

const parentValue = computed(() => {
    if (!props.field.parentKey) return null
    const parent = entityState[props.field.parentKey]
    return parent?._id || parent
})

function getId(val) {
  return val?._id || val
}

const items = computed(() => {
  if (!parentValue.value) return baseItems.value

  return baseItems.value.filter(item =>
    getId(item[props.field.parentKey]) === parentValue.value
  )
})

watch(
  () => entityState[props.field.parentKey],
  (val) => {
    resetEntity(props.field.key)
    localValue.value = null
    }
)

function onSelect(selectedId) {
  // const oldValue = localValue.value
  // console.log("log oldValue", oldValue)
  const newValue = items.value.find( item => item.id === selectedId)
  sendLog("debug", "onSelect_context", newValue)
  const canUpdate = updateRolesEntityPath({id:selectedId, entityPath: newValue?.path, typename: newValue?.__typename, oldValue: entityState._id})
  if(!canUpdate) return 

  localValue.value = selectedId

  updateEntity(props.field.key, selectedId)

  if (props.drawerMode !== 'create'){
    const selectedItem = baseItems.value.find(item => item.id === selectedId)
    if (!selectedItem) return

    if(props.field.listViewType !== "user") 
      updateEntity("path", `${selectedItem.path}/${entityState?.name}`)
  }
  else{
    const selectedItem = baseItems.value.find(item => item.id === selectedId)
    if (!selectedItem) return

    applyPathPrefix(selectedItem)
    applyParentMappings(selectedItem)
  }
  
}

function updateRolesEntityPath({id, entityPath, typename, oldValue}){
  if (props.drawerMode == 'create' ) return true
  if(props.field.listViewType === "user"){
      updateEntity("roles", [])
      updateEntity("roles_metadata", {id, entityPath, typename})
      disableFormSubmission(true)
      loader.setAlert({
        message: "Please reset permissions",
        color:"yellow",
        timeout: 5000
      })
      return true
  }
  else if(props.field.listViewType === "company"){
    const user = entityStore.hasUserUndertheEntity("company", oldValue)
    const department = entityStore.hasDepartmentUndertheEntity("company", oldValue)
    if(user || department){
      return loader.setAlert({
    message: "Please remove users from current company first",
    color:"red",
    timeout: 5000})
    return false 
  }
    else
       return true
  }
  else if(props.field.listViewType === "department"){
    const result = entityStore.hasUserUndertheEntity("department", oldValue)
    if(result){
      return loader.setAlert({
    message: "Please remove users from current department first",
    color:"red",
    timeout: 5000})
    return false 
    }
    else return true
  }
}

function applyPathPrefix(item) {
  if (!item?.path) return
  updateEntity('pathPrefix', item.path)
}

function applyParentMappings(item) {
  props.field.parentList?.forEach(parentKey => {
    const parent = item[parentKey]
    if (parent?._id) {
      updateEntity(`${parentKey}_hidden`, parent._id)
    }
  })
}

const localValue = ref(props.modelValue?.name ?? null)
const entityIsActive = ref(props.modelValue?.isActive ?? "yes")
watch(
  () => localValue.value,
  (val) => {
    const newValue = items.value.find( item => item.id === localValue.value)
    entityIsActive.value = newValue?.isActive
  }
)

</script>
<template>
  <div class="d-flex align-center ga-2">
  <v-select
    :model-value="localValue"
    :label="field.label"
    :items="items || []"
    item-title="name"
    item-value="id"
    @update:modelValue="onSelect"
    :clearable="!field.readonly(userStore.accesslevel)"
    :readonly="field.readonly(userStore.accesslevel) && drawerMode !== 'create'"
  />
  <v-chip
      size="small"
      :color="entityIsActive === 'yes' ? 'success' : 'error'"
      variant="tonal"
    >
      <v-icon start size="10">
        mdi-circle
      </v-icon>
      {{ entityIsActive === "yes" ? 'Active' : 'Inactive' }}
    </v-chip>
  </div>
  
  <!-- <div></div> -->
</template>